export const KNOWLEDGE_FORM_TEXTS = {
  // Page headers
  HEADERS: {
    EDIT: 'Edit',
  },
  // Knowledge content sections
  CONTENT: {
    USER_INSTRUCTIONS: {
      SECTION_TITLE: 'User instructions',
      CHECKBOX_LABEL: 'User instructions visible',
      DESCRIPTION_LABEL: 'User instructions overview',
      PLACEHOLDER:
        'Provide an overview or introduction for this knowledge content section',
      HINT: 'Add instructions that help users understand and use this offering. Examples could include step-by-step guides, tutorials, and detailed procedures.',
      TABLE_COLUMNS: {
        STEP_NAME: 'Instruction title',
        STEP_DESCRIPTION: 'Instruction details',
        STEP_PUBLISH: 'Published',
      },
      CTA: 'Add User instructions content',
    },
    BEST_PRACTICES: {
      SECTION_TITLE: 'Best practices',
      CHECKBOX_LABEL: 'Best practices visible',
      HINT: 'Add tips and best practices for smooth use. Include suggestions for handling common issues',
      TABLE_COLUMNS: {
        TITLE: 'Best practice title',
        DESCRIPTION: 'Best practice description',
        PUBLISH: 'Published',
      },
      CTA: 'Add Best practices content',
    },
    LEARNING_RESOURCES: {
      SECTION_TITLE: 'Authoritative resources',
      CHECKBOX_LABEL: 'Authoritative resources visible',
      HINT: 'Add links to educational resources for authoritative how to use the offering. Include tutorials, documentation, or training materials',
      TABLE_COLUMNS: {
        LINK_NAME: 'Authoritative resource link name',
        LINK: 'Authoritative resource link',
        PUBLISH: 'Published',
      },
      CTA: 'Add Authoritative resources content',
    },
    TECHNICAL_RESOURCES: {
      SECTION_TITLE: 'Technical resources',
      CHECKBOX_LABEL: 'Technical resources visible',
      HINT: 'Add resources with technical information for tech-savvy users, including essential technical details about the offering',
      TABLE_COLUMNS: {
        LINK_NAME: 'Technical resource link name',
        LINK: 'Technical resource link',
        PUBLISH: 'Published',
      },
      CTA: 'Add Technical resources content',
    },
    INTEGRATIONS: {
      SECTION_TITLE: 'Integrations',
      CHECKBOX_LABEL: 'Integrations visible',
      OVERVIEW_LABEL: 'Integrations overview',
      OVERVIEW_PLACEHOLDER:
        'Enter a brief overview of the integration capabilities for your offering',
      HINT: "Add integration details about the offering's built-in capabilities and automation features that simplify the integration of applications. Include information about compatibility with external databases, systems, and software",
      TABLE_COLUMNS: {
        TITLE: 'Integration title',
        DESCRIPTION: 'Integration description',
        LINK_NAME: 'Integration link name',
        LINK: 'Integration link',
        PUBLISH: 'Published',
      },
      CTA: 'Add Integrations content',
    },
    FAQ: {
      SECTION_TITLE: 'FAQ',
      CHECKBOX_LABEL: 'FAQ visible',
      HINT: 'Add common questions and their corresponding answers. Include typical user concerns, issues, or inquiries about the offering',
      TABLE_COLUMNS: {
        QUESTION: 'Question',
        ANSWER: 'Answer',
        PUBLISH: 'Published',
      },
      CTA: 'Add FAQ content',
    },
    ADDITIONAL_RESOURCES: {
      SECTION_TITLE: 'Additional resources',
      CHECKBOX_LABEL: 'Additional resources visible',
      HINT: 'Add additional resources and references related to the offering. Include materials that complement the basic information and help further maximize its potential',
      TABLE_COLUMNS: {
        LINK_NAME: 'Additional resource link name',
        LINK: 'Additional resource link',
        PUBLISH: 'Published',
      },
      CTA: 'Add Additional resources content',
    },
    SUCCESS_STORIES: {
      SECTION_TITLE: 'Success stories',
      CHECKBOX_LABEL: 'Success stories visible',
      HINT: "Add narratives showcasing how customers have successfully used the offering to achieve positive outcomes. Include metrics, testimonials, and other evidence demonstrating the offering's effectiveness",
      TABLE_COLUMNS: {
        TITLE: 'Success story title',
        DESCRIPTION: 'Success story description',
        PUBLISH: 'Published',
      },
      CTA: 'Add Success stories content',
    },
    RELEASE_NOTES: {
      SECTION_TITLE: 'Release notes',
      CHECKBOX_LABEL: 'Release notes visible',
      HINT: 'Add documents that accompany updates or new releases of the offering. Include resources detailing new features, enhancements, bug fixes, and any other changes to the offering',
      TABLE_COLUMNS: {
        NAME: 'Release note name',
        HEADER: 'Release note header',
        DESCRIPTION: 'Release note description',
        LINK: 'Release note link',
        PUBLISH: 'Published',
      },
      CTA: 'Add Release notes content',
    },
  },

  // Popups
  ERRORS: {
    VALIDATION: 'Visible sections are empty',
    HEADER:
      'Fields for the following sections are required when they are visible:',
    MESSAGE: 'Please fill out the required fields and try again',
    USER_INSTRUCTIONS_REQUIRED: 'User instructions',
    USER_INSTRUCTION_LONG_DESCRIPTION_REQUIRED: 'User instruction overview',
    BEST_PRACTICES_REQUIRED: 'Best practices',
    LEARNING_RESOURCES_REQUIRED: 'Authoritative resource',
    TECHNICAL_RESOURCES_REQUIRED: 'Technical resources',
    INTEGRATIONS_REQUIRED: 'Integrations',
    INTEGRATION_LONG_DESCRIPTION_REQUIRED: 'Integration description',
    FAQ_REQUIRED: 'FAQ',
    ADDITIONAL_RESOURCES_REQUIRED: 'Additional resources',
    SUCCESS_STORIES_REQUIRED: 'Success stories',
    RELEASE_NOTES_REQUIRED: 'Release notes',
  },
};
